import { v4 as uuidv4 } from 'uuid'
import { loginStart, loginSuccess, loginFailure, logout, setUniqueDeviceId } from '../../reducers/auth/authSlice'

// ** Handle User Login with proper error handling
export const handleLogin = (data) => {
    return (dispatch) => {
        try {
            dispatch(loginStart())

            if (data && data.userType) {
                // Dispatch success action
                dispatch(loginSuccess(data))

                localStorage.setItem('userData', JSON.stringify(data))
                if (localStorage.getItem("userList")) {
                    const oldData = JSON.parse(localStorage.getItem("userList"))
                    const index = oldData.findIndex(function (person) {
                        return person.id === data.id
                    })
                    if (index === -1) {
                        oldData.push(data)
                        localStorage.setItem('userList', JSON.stringify(oldData))
                    }
                } else {
                    localStorage.setItem('userList', JSON.stringify([data]))
                }
            } else {
                dispatch(loginFailure('Invalid user data'))
            }
        } catch (error) {
            dispatch(loginFailure(error.message || 'Login failed'))
        }
    }
}

// ** Handle User Logout
export const handleLogout = () => {
    return (dispatch) => {
        try {
            dispatch(logout())

            // Clean up localStorage
            localStorage.removeItem('userData')
            localStorage.removeItem('userList')
            localStorage.removeItem('authentication_key')
            localStorage.removeItem('user_name')
        } catch (error) {
            console.error('Logout error:', error)
        }
    }
}

// ** Handle Unique Device ID
export const handleUniqueDeviceId = () => {
    return (dispatch) => {
        try {
            let deviceId = localStorage.getItem("uniqueDeviceId")

            if (!deviceId) {
                deviceId = uuidv4()
                localStorage.setItem('uniqueDeviceId', deviceId)
            }

            // Update Redux state with device ID
            dispatch(setUniqueDeviceId(deviceId))
        } catch (error) {
            console.error('Error setting unique device ID:', error)
        }
    }
}

